import React, { useState, useEffect } from "react";
import "./bannerWithHeading.css";

export default function BannerWithHeading(props) {
  const [bannerImage, setBannerImage] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
      
    document.getElementById(
      "sectionTagId"
    ).style.backgroundImage = `url(${props.bannerImage})`;
    setBannerImage(props.bannerImage);
    let color = props.headingColor ? props.headingColor : "#ffffff"
    document.getElementById("bannerTitle").style.color = color;
    setImageLoaded(true)
  });

  return (
    <>

      <section id="sectionTagId" className={"imageBanner"}>
      <div className={imageLoaded ?"bannerOverlay": ""}></div> 
          <p id="bannerTitle" className="bannerTitles">{props.heading}</p>
      </section>

    </>
  );
}
